namespace $.$$ {

	const { rem } = $mol_style_unit

	$mol_style_define( $eve_tab_group, {
		border: {
			bottom: {
				width: rem( 0.0625 ),
				style: 'solid',
				// TODO перееехать на eve
				color: 'var(--mol_theme_line)',
			} as any,
		},
	} )
}

